const magnoliaWebDomainRegex = /^(https:\/\/)?(dev\.)?magnolia.com/;
const magnoliaAuthDomainRegex = /^(https:\/\/)?(dev-)?account.magnolia.com/;
const localHostPortRegex = /^http?:\/\/127\.0\.0\.1:9292/;

const isMagnoliaWebDomain = (url) => !!url.match(magnoliaWebDomainRegex);
const isMagnoliaAuthDomain = (url) => !!url.match(magnoliaAuthDomainRegex);
const isMagnoliaLocalhost = (url) => !!url.match(localHostPortRegex);

function checkIsExternalLink(href) {
  const isAuthenticationLink = href.includes('/customer_authentication/');
  const hrefIsHttpLink = href.startsWith('//') || href.startsWith('http:') || href.startsWith('https:');
  const isAuthLink = isMagnoliaAuthDomain(href);
  return {
    isExternalLink:
      (hrefIsHttpLink && !(isMagnoliaWebDomain(href) || isMagnoliaLocalhost(href))) || isAuthenticationLink,
    isAuthLink,
  };
}
